<template>
  <b-container class="container-layout" fluid>
    <b-row align-h="center" class="mt-5">
      <p
        class="report-text-title mt-5"
      >Realice una busqueda por colegio o por codigo de key de acceso</p>
    </b-row>
    <b-row>
      <b-col cols="12" class="results-content-search mt-3">
        <b-form-group id="form-search-simulacro">
          <img src="@/assets/images/Search.svg" />
          <b-form-input
            id="input-2"
            v-model="search"
            required
            placeholder="Busca por código de key o grado y sección"
            size="lg"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="3" class="results-content-report mt-n5">
        <p class="results-text-title-report">Reportes</p>
      </b-col>
      <b-col cols="12" lg="9" class="results-title-line-report"></b-col>
      <b-col
        cols="12"
        class="results-content-simulacro-principal"
        v-for="(items,key) in filteredData"
        :key="key"
      >
        <table-results :item="items" :id="key" :filter-key="search" :content="content"></table-results>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TableResults from "@/components/Global/Results";
export default {
  name: "Reportes",
  components: { TableResults },
  data: () => ({
    search: "",
    data: [],
    premedios: [],
    content: {
      button1: {
        name: "POR GRUPO ",
        url: "/admin/result/list-simulacros"
      },
      button2: {
        name: "POR ESTUDIANTE",
        url: "/admin/result/resultados-estudiantes"
      }
    }
  }),
  mounted() {
    this.$store.dispatch("setActiveModalSend", false);
    //this.$store.dispatch('setNav', false)
    this.search = localStorage.getItem("search")
      ? localStorage.getItem("search")
      : this.search;
    if (this.search == "") {
      this.$store.dispatch("setNav", false);
    } else {
      this.$store.dispatch("setNav", "active");
    }
    localStorage.removeItem("search")

    //this.search c= this.store.state.search ? this.store.state.search : this.search
    console.log(this.currentName);
    this.$store.dispatch("setModulo", "REPORTES DE SIMULACROS");
    this.GetKeysAsesorAll();
  },
  methods: {
    GetKeysAsesorAll() {
      this.$store
        .dispatch("GetKeysAsesorAll")
        .then(response => {
          this.data = response.data.keys;
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  filters: {
    fixed(value) {
      return parseFloat(value).toFixed(0);
    }
  },
  computed: {
    currentName() {
      return this.$route;
    },
    filteredData: function() {
      var data = this.data;
      var filterKey = this.search && this.search.toLowerCase();
      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }
//      localStorage.removeItem("search")
      return data;

    }
  }
};
</script>
<style scoped>
</style>